export const environment = {
  production: true,
  baseHref: '',
  baseUrl: 'cheetah/api/',
  baseChirpUrl: 'chirp/api/',
  baseGoatUrl: 'goat/api/',
  releaseName: 'release-3.5.1-484',
  buildNumber: '919d12bda8-',
};
